export default function PublicationList(props) {
    return (
        <div className="w-full px-5 py-4 bg-[#F8F8F8] rounded-lg ">
            <p className="text-[#CE5347] text-[14px] font-semibold">{props.author}</p>
            <p className="text-[14px] font-normal"> {props.topic}</p>
        </div>
    )

}
